import { render, staticRenderFns } from "./TreasuryTransactionAdd.vue?vue&type=template&id=a9fcfb02&scoped=true&"
import script from "./TreasuryTransactionAdd.vue?vue&type=script&lang=js&"
export * from "./TreasuryTransactionAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9fcfb02",
  null
  
)

export default component.exports